// volto-guides — tenant addon for guides.ljusa-tider.se, the platform's
// PUBLIC commons: the single shared home for cross-tenant content —
// the marketing tutorial, sector modules, blog/news, shared guides
// (DR-2026-270; delivery architecture decided s527, marketing-tutorial thread).
//
// Deliberately minimal at v0.1.0: en only over the converged VLT-8 baseline.
// Additional language roots are added when translated tutorial content exists
// to fill them (isMultilingual stays true so that step is additive).
// Public-by-default — but the token-truth UserTools slot override ships anyway
// per GUIDE-PLATFORM-001 §6.1 (the editor login indicator; VLT's Anontools
// renders from nick's non-existent @actions endpoint — BUG-2026-211/217).

import { applyTenantBaseline } from 'volto-tenant-baseline/applyTenantBaseline';
import GuidesColophon from './components/GuidesColophon';

const NullSlot = () => null;

const applyConfig = (config) => {
  config.settings.supportedLanguages = ['en'];
  config.settings.defaultLanguage = 'en';
  config.settings.isMultilingual = true;

  // -- Fleet baseline (DR-2026-272 / CR-2026-077, guides registration s529) --
  // Token-truth UserTools over VLT's Anontools + tenantBaseline settings,
  // versioned once in volto-tenant-baseline; the tenant-local UserTools /
  // LanguageSelector / 880px-token copies were removed with this migration.
  // isCommons: this IS the commons — the baseline suppresses the Guides
  // self-link and activates ReturnLink (the ?from=<tenantKey> way back to
  // the originating tenant; fleet registry ships in the addon).
  config = applyTenantBaseline(config, { isCommons: true });

  // -- Footer colophon: honest stack line over VLT's Plone default --
  // (DR-2026-248 slot pattern; ekonomi precedent. VLT's default credits
  // Plone as the CMS — this fleet runs Nick.) The kitconcept logo strips
  // are nulled the same way ekonomi does.
  config.registerSlotComponent({ slot: 'preFooter', name: 'footerLogos', component: NullSlot });
  config.registerSlotComponent({ slot: 'postFooter', name: 'PostFooterFollowUsLogoAndLinks', component: NullSlot });
  config.registerSlotComponent({ slot: 'postFooter', name: 'Colophon', component: GuidesColophon });

  return config;
};

export default applyConfig;
